

const userDownload = (data, fileName = "download") => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(data.blob);
    a.target = '_blank';
    a.download = fileName;
    a.click();
}

const createFile = async (id, type) => {
    const path = `/api/estate/download/${type}/${id}`;
    return fetch(path, {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
        },
        credentials: 'same-origin'
    })
        .then(res => {
            const contentType = res.headers.get('Content-Type') || '';
            // JSONでエラーが返ってきた場合は、JSONを返す
            if (contentType.includes('application/json')) {
                return res.json();
            }
            return res.blob().then(blob => ({
                contentType: contentType,
                blob: blob
            }));
        });
}

const getExtension = (contentType) => {
    let fileExtension = '';
    switch (contentType) {
        case 'application/pdf':
            fileExtension = 'pdf';
            break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            fileExtension = 'xlsx';
            break;
        case 'image/jpeg':
            fileExtension = 'jpg';
            break;
        case 'image/png':
            fileExtension = 'png';
            break;
        case 'application/zip':
            fileExtension = 'zip';
            break;
        case 'application/x-zip-compressed':
            fileExtension = 'zip';
            break;
        default:
            alert('ダウンロードできるファイルではありません。' + contentType);
            return;
    }
    return fileExtension;
}

const download = () => {
    if (document.querySelector('.c-buttons-download') === null) return;
    const downloadButton = document.querySelector('.c-buttons-download');
    downloadButton.addEventListener('click', async (e) => {
        e.preventDefault();
        downloadButton.dataset.loading = '';
        const [type, id] = downloadButton.dataset.estateKey.split('_');
        const resp = await createFile(id, type);
        // JSONでエラーが返ってきた場合は、アラートを表示して終了
        if (resp?.status === 'error') {
            alert(resp.message);
            delete downloadButton.dataset.loading;
            return false;
        }
        const fileExtension = getExtension(resp.contentType);
        userDownload(resp, `estate-${id}.${fileExtension}`);
        delete downloadButton.dataset.loading;
        return false;
    });
}

export default download;
